import { PushHistory } from './PushHistory';
import { fixtureProps, linkedRow, suppressedRow } from './fixtures';
const meta = {
    title: 'Features/Settings/Technicians/PushHistory',
    component: PushHistory,
    parameters: { layout: 'padded' }
};
export default meta;
export const AllThreeRowKinds = { args: fixtureProps };
export const PlatformUnavailable = {
    args: Object.assign(Object.assign({}, fixtureProps), { platform: {
            unavailable: true,
            health: 'Reachable — a read failed, but GET /health answered.',
            error: '401 unauthorized: bad key'
        }, device: { state: 'unauthorized', deviceModel: null, registeredAt: null, notificationsOn: null }, rows: [Object.assign(Object.assign({}, linkedRow), { kind: 'rails_only', platform: null }), suppressedRow] })
};
export const LimitReached = { args: Object.assign(Object.assign({}, fixtureProps), { capped: true }) };
export const Empty = { args: Object.assign(Object.assign({}, fixtureProps), { rows: [] }) };
